import React from 'react';
import { FaRegHandshake, FaBook, FaGlobe } from 'react-icons/fa';
import { TiGroupOutline } from 'react-icons/ti';
import { MdOutlineManageAccounts, MdOutlineRocketLaunch, MdPsychology } from 'react-icons/md';
import {
  GiPublicSpeaker,
  GiLightBulb,
  GiPencilBrush,
  GiStairsGoal,
  GiChameleonGlyph,
  GiBullseye,
  GiBodyBalance,
} from 'react-icons/gi';
import { BsFillCpuFill } from 'react-icons/bs';
import { GrGamepad } from 'react-icons/gr';
import { BiMoviePlay } from 'react-icons/bi';
import { AiOutlineAreaChart } from 'react-icons/ai';

export const aboutMeInfo = [
  `I am a frontend developer with an economics background and a strong passion for technology and coding. My main areas of expertise include HTML, CSS, SASS, JavaScript, React, and Webpack. I am also outgoing and ambitious, with a strong desire for self-improvement, both personally and professionally. My main goal is to build top-class web applications and websites.`,
];

export const personalityData = [
  { id: 1, icon: <FaRegHandshake className="personality-icon" />, name: 'Interpersonal skills' },
  { id: 2, icon: <GiPublicSpeaker className="personality-icon" />, name: 'Public speaking' },
  { id: 3, icon: <GiLightBulb className="personality-icon" />, name: 'Resourceful' },
  { id: 4, icon: <TiGroupOutline className="personality-icon" />, name: 'Extrovert' },
  { id: 5, icon: <GiPencilBrush className="personality-icon" />, name: 'Creative' },
  { id: 6, icon: <GiChameleonGlyph className="personality-icon" />, name: 'Flexible' },
  { id: 7, icon: <MdOutlineRocketLaunch className="personality-icon" />, name: 'Ambitious' },
  { id: 8, icon: <GiStairsGoal className="personality-icon" />, name: 'Decisive' },
  { id: 9, icon: <GiBullseye className="personality-icon" />, name: 'Direct' },
  { id: 10, icon: <MdOutlineManageAccounts className="personality-icon" />, name: 'Self-Improvement' },
];

export const hobbiesData = [
  { icon: <BsFillCpuFill className="hobbies-icon" />, name: 'Technology' },
  { icon: <AiOutlineAreaChart className="hobbies-icon" />, name: 'Economy' },
  { icon: <FaGlobe className="hobbies-icon" />, name: '(Geo)politics' },
  { icon: <MdPsychology className="hobbies-icon" />, name: 'Psychology' },
  { icon: <FaBook className="hobbies-icon" />, name: 'Books' },
  { icon: <GrGamepad className="hobbies-icon" />, name: 'Games' },
  { icon: <BiMoviePlay className="hobbies-icon" />, name: 'Movies & anime' },
  { icon: <GiBodyBalance className="hobbies-icon" />, name: 'Calistenics' },
];
